module.exports = __webpack_public_path__ + "img/infirmiere.b338fed4.jpg";